import { selectCategory } from "../slices/searchSlice";

/**
 *
 * @param {Function} navigate - react-router-dom navigate
 * @param {string} [query]    - Optional query to seed the AI page with
 */
export const navigateToAISearch = (navigate, query) => {
  if (typeof navigate !== "function") return;
  const trimmed = (query || "").trim();
  const target = trimmed
    ? `/ai-search?q=${encodeURIComponent(trimmed)}`
    : "/ai-search";
  navigate(target);
};

/**
 * Centralized handler for category and subcategory actions in the Search module.
 * @param {Object} category - The category or subcategory object.
 * @param {Object} helpers - Utilities like dispatch, navigate, and setActiveSubcategories, setExpandedCard.
 */
export const handleAction = ({ action, route, url, subcategories, key, parentKey, queryKeyword, guideData }, helpers) => {
  const { dispatch, navigate, setActiveSubcategories, setExpandedCard } = helpers;

  switch (action) {
    case "query":
      // Determine the final keyword to use for the API request
      const finalQueryKeyword = queryKeyword || key;

      if (parentKey) {
        // Subcategory case: Navigate to `/search/parentKey/key`
        dispatch(selectCategory({ key, parentKey, queryKeyword: finalQueryKeyword }));
        console.log(`Navigating to query route: /search/${parentKey}/${key} with queryKeyword: "${finalQueryKeyword}"`);
        navigate(`/search/${parentKey}/${key}`);
      } else {
        // Main category case: Navigate to `/search/key`
        dispatch(selectCategory({ key, queryKeyword: finalQueryKeyword }));
        console.log(`Navigating to query route: /search/${key} with queryKeyword: "${finalQueryKeyword}"`);
        navigate(`/search/${key}`);
      }
      break;

    case "popup":
      // Set active subcategories for the popup
      if (subcategories) {
        setActiveSubcategories({
          subcategories,
          mainCategory: key,
        });
      }
      break;

    case "navigate":
      // Navigate to an internal route
      if (route) navigate(route);
      break;

    case "externalLink":
      // Open external URL in a new tab
      if (url) window.open(url, "_blank");
      break;

    case "expandedCard":
      // Set the expanded card state
      if (guideData) {
        console.log("Opening ExpandedCard for:", guideData);
        setExpandedCard(guideData);
      }
      break;

    default:
      console.error("Unknown action type:", action);
  }
};
